import { Typography } from "antd";
import SessionRow from "./SessionRow";

import "./SessionDisplayList.css";

const SessionDisplayList = ({ title, sessions }) => {
  return sessions ? (
    <div className="carisity-session-display-list">
      <Typography.Title
        level={4}
        type="secondary"
        className="carisity-session-display-list-title"
      >
        {title}
      </Typography.Title>
      {sessions.map((s) => (
        <SessionRow sessionDetails={s} key={s.session.SessionId} />
      ))}
      {sessions.length === 0 && (
        <Typography.Paragraph type="secondary">
          No sessions
        </Typography.Paragraph>
      )}
    </div>
  ) : null;
};

export default SessionDisplayList;
